import { theme } from '../../theme'
import { palette } from '../../tokens'
import { generateIcon } from './generateIcon'

export const icons = {
  sortUnSort: generateIcon({ icon: 'unsorted' }),
  sortAscending: generateIcon({ icon: 'sort-asc' }),
  sortDescending: generateIcon({ icon: 'sort-desc' }),
  menu: generateIcon({ icon: 'menu' }),
  filter: generateIcon({ icon: 'filter' }),
  clipboardCut: generateIcon({ icon: 'cut' }),
  clipboardCopy: generateIcon({ icon: 'copy' }),
  clipboardPaste: generateIcon({ icon: 'paste' }),
  save: generateIcon({ icon: 'download' }),
  groupExpanded: generateIcon({
    icon: 'arrow-down',
    width: 12,
    height: 8,
  }),
  groupContracted: generateIcon({ icon: 'arrow-right' }),
  smallRight: generateIcon({ icon: 'arrow-right' }),
  check: generateIcon({ icon: 'check' }),
  csvExport: generateIcon({ icon: 'save' }),
  excelExport: generateIcon({ icon: 'save' }),
  groupLoading: generateIcon({ icon: 'loader' }),
  smallDown: generateIcon({ icon: 'arrow-down', width: 12, height: 8 }),
}

export function generateSprite() {
  const sprite = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  sprite.id = 'datatable-sprite'
  Object.assign(sprite.style, {
    display: 'none',
  })
  sprite.innerHTML = `
    <defs>
      <symbol id="unsorted" viewBox="0 0 12 12">
        <path d="M4 6.75L6.25 9L8.5 6.75" stroke="${palette.grey50}" strokeWidth="0.75"></path>
        <path d="M4 4.25L6.25 2L8.5 4.25" stroke="${palette.grey50}" strokeWidth="0.75"></path>
      </symbol>
      <symbol id="sort-asc" viewBox="0 0 12 12">
        <path d="M4 4.25L6.25 2L8.5 4.25" stroke="${theme.colors.primary.highlightColor}" stroke-width="0.75"/>
      </symbol>
      <symbol id="sort-desc" viewBox="0 0 12 12">
        <path d="M4 6.75L6.25 9L8.5 6.75" stroke="${theme.colors.primary.highlightColor}" stroke-width="0.75"/>
      </symbol>
      <symbol viewBox="0 0 12 13" id="menu">
        <path
          d="M.01 1.757h11.385M.01 10.329h11.385M0 6.041h8.597"
          stroke="currentColor"
        ></path>
      </symbol>
      <symbol
        id="filter"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        className="feather feather-filter"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
      </symbol>
      <symbol id="download" viewBox="0 0 12 12">
        <path
          stroke="#B7B7B9"
          strokeMiterlimit="10"
          d="M2 11.5h8M6 9.02V0M3 6.03l3 3L9.01 6"
        ></path>
      </symbol>
      <symbol id="arrow-right" viewBox="0 0 4 6">
        <path d="M1 5L3 3L1 1" stroke="#BFBFBF" />
      </symbol>
      <symbol id="arrow-down" viewBox="0 0 4 6">
        <path d="M1 1L3 3L5 1" stroke="currentColor" />
      </symbol>
      <symbol id="check" viewBox="0 0 14 11" color="#00CF9D">
        <path
          d="M1 4.2 5.5 9 13 1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </symbol>
      <symbol id="external" viewBox="0 0 8 8">
        <path d="M7.667.333L.236 7.764M.663.334h7.004V7.34" stroke="currentColor"/>
      </symbol>
      <symbol id="loader" viewBox="0 0 100 100">
        <path fill="none" stroke="currentColor" stroke-width="12" d="M50 15a35 35 0 1 0 24.749 10.251" transform-origin="center" />
        <path fill="currentColor" d="M49 3v24l12-12L49 3" transform-origin="center" />
      </symbol>
      <symbol id="search" viewBox="0 0 17 17" color="#B7B7B9" fill="none">
        <path d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16L12 12" stroke="currentColor" strokeWidth="1.5" />
      </symbol>
    </defs>
  `
  return sprite
}
